export default __webpack_public_path__ + "static/media/pdfImage.9b8a71eb.png";